export default __webpack_public_path__ + "static/media/beanLoading.993da46f.gif";